import { InstalledExtension } from "@dashboard/extensions/types";
import { PluginBaseFragment } from "@dashboard/graphql";

// MAXCEI's own plugins (e.g. CEGID) start inactive; list them anyway so their
// settings page is reachable now that the Explore page is gone.
export const byActivePlugin = (plugin: PluginBaseFragment) => {
  return (
    plugin?.id?.startsWith("maxcei.") ||
    plugin?.globalConfiguration?.active === true ||
    plugin?.channelConfigurations?.some(config => config.active)
  );
};

export const sortByName = (a: InstalledExtension, b: InstalledExtension) => {
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }

  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }

  return 0;
};
